module.exports = __webpack_public_path__ + "static/media/DownloadIcon.1b12ab78.svg";